import { render, staticRenderFns } from "./departmentSelect.vue?vue&type=template&id=0a03317d&scoped=true&"
import script from "./departmentSelect.vue?vue&type=script&lang=js&"
export * from "./departmentSelect.vue?vue&type=script&lang=js&"
import style0 from "./departmentSelect.vue?vue&type=style&index=0&id=0a03317d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a03317d",
  null
  
)

export default component.exports